/* eslint-disable no-mixed-operators */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import cameraRollIcon from 'Assets/camera-roll.svg';
import viewersIcon from 'Assets/viewers.svg';
// import { Button } from 'Components';
import StripeCheckout from 'react-stripe-checkout';
import { config } from 'Config';
import useSWR from 'swr';
import { dataFetcher, endpoints, baseUrl, STRIPE_PUBLIC_KEY } from 'Api';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { loadStripe } from '@stripe/stripe-js';
import styles from './index.module.css';
import TickCircle from '../../../../Assets/check-circle.png';
import Button from './common/Button';

const AffliatePlan = ({
  AffliateSpecial,
  managerTokenFunction,
  needToggle,
  isSwitchPlan,
  hideToggle,
  setIsSwitchPlan,
  plan,
  product_name,
  sub_title,
  amount,
  priceDetails,
  storage,
  viewers,
  price_id,
  setToken,
  setPriceId,
  setTrial_period_days,
  userIsSignedIn,
  isExtended,
  hasTrial,
  totalTrialDays,
  planId,
  contentId,
  contentType,
  freePlanId,
  color,
  description,
  price_description
}) => {
  const { allPlans, setAppSnackbar, subscriptionDetails, plansPage, setPlansPage,
    currentSelectedPlan, setCurrentSelectedPlan, getSubscription, setUserDetails, userDetails, langText, setIsTrail, clearChecked, setTrial, setAffliatePlanId, bigUserData, apiCALL, setExpressLoading, expressloading, mangerToken, userAccessedData } = useContext(AppContext);
  const { forceAutoSignin, getToken } = useContext(AuthContext);
  const location = useLocation();
  const planText = langText?.settings?.billPayment?.planList;
  const commonText = langText?.common;
  const navigate = useNavigate();
  const [money, setMoney] = useState(amount);
  const [size, setSize] = useState(storage);
  const [currentPlanBenefit, setCurrentPlanBenefit] = useState('');
  const [isExtra500, setIsExtra500] = useState(false);
  const [isAddOn, setIsAddon] = useState(false);
  const [selectedPlan, selectPlan] = useState(undefined);
  const [isDisabledUpgrade, setIsDisabledUpgrade] = useState(false);
  const [planViewer, setPlanViewer] = useState(viewers);
  const [planDescription, setPlanDescription] = useState(description);
  const [PriceDescription, setPriceDescription] = useState(price_description);
  const [data, setUpdateData] = useState();
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);
  const hideUploadModal = () => { setUploadModalVisibility(false); };
  const [subscriptionPlanDetails, setSubscriptionPlanDetails] = useState({
    subscriptionPlan: subscriptionDetails?.subscription?.plan,
    plan_price: subscriptionDetails?.plan_price,
    plan_price2: subscriptionDetails?.plan_price2,
    forStandard: price_id,
    myPlanName: subscriptionDetails?.current_plan,
    planaction2: subscriptionDetails?.planaction2,
    planaction: subscriptionDetails?.planaction,
    disk_used_mb: 0,
    total_viewer: 0,
    max_storage_mb: 0,
    subscription: (typeof subscriptionDetails?.subscription === 'string'
      || subscriptionDetails?.subscription instanceof String)
      ? subscriptionDetails?.subscription : undefined,
    id: subscriptionDetails?.subscription?.id,
    status: subscriptionDetails?.subscription?.status,
    degrade: subscriptionDetails?.degrade,
    upgrade: subscriptionDetails?.upgrade,
    isNewUser: subscriptionDetails?.is_newUser,
    isFree: subscriptionDetails?.subscription?.is_free,
    hasActivePlan: subscriptionDetails?.has_activePlan,
    paymentMethods: subscriptionDetails?.paymentMethods,
    isAddonAllowed: subscriptionDetails?.is_addon_allowed,
    amount: subscriptionDetails?.subscription?.amount,
    addonRate: subscriptionDetails?.subscription?.addon_rate,
    totalStorageText: subscriptionDetails?.subscription?.total_storage_text,
    totalStorage: subscriptionDetails?.subscription?.total_storage,
    maxAddonAllowedText: subscriptionDetails?.subscription?.max_add_on_allowed_text,
    maxAddonAllowed: subscriptionDetails?.subscription?.max_add_on_allowed,
    isUnlimited: subscriptionDetails?.subscription?.is_unlimited,
    maxViewRequest: subscriptionDetails?.subscription?.max_view_request,
    paymentProcessing: parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 4 && subscriptionDetails?.has_activePlan,
    paymentProcessingText: planText?.paymentProcessing || 'Payment Processing',
    paymentRetry: parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 2 && subscriptionDetails?.has_activePlan,
    paymentRetryText: planText?.paymentRetry || 'Payment Retry',
    purchasePlanId: subscriptionDetails?.subscription?.purchase_plan_id
  });
  const [openModal, setModal] = useState(false);

  // Stripe and user data setup
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
  const userData = apiCALL?.data?.userDetails[0] || bigUserData || userAccessedData;
  const userId = userData?.id || userData?.userId || userAccessedData?.userId || userAccessedData?.id || localStorage.getItem('temp_user_id');

  const currentPlanId = subscriptionPlanDetails.id === planId;

  const checkSize = (size) => {
    const bytes = size * 1048576;
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${parseFloat((bytes / (1024 ** i)).toFixed(2))} ${units[i]}`;
  };

  const { isValidating: uploadingVisibility, mutate: updateVisibilityContent } = useSWR([
    contentType === 'video' ? endpoints.addVideoContent : endpoints.addPhotoContent, data
  ], {
    fetcher: (url, formData) => dataFetcher(url, formData),
    onSuccess: ({ success, total_count, message }) => {
      if (success) {
        // setUploadModalVisibility(true);
        // setVideoId(undefined);
        if (contentType === 'video') {
          setUserDetails({ ...userDetails, totalVideoUploaded: 1, totalContentUploaded: 1 });
        } else {
          setUserDetails({
            ...userDetails,
            totalContentUploaded: 1
          });
        }
        hideUploadModal();
        // setTimeout(() => { navigate(Pathname.yourVideos); }, 5000);
        setTimeout(() => { navigate(Pathname.yourVideos); }, 500);
      } else {
        setAppSnackbar({ isVisible: true, type: 'error', message });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
    },

  });
useEffect(() => {
  clearChecked();
}, []);

  useEffect(() => {
    if (data) {
      updateVisibilityContent();
    }
  }, [data]);

  useEffect(() => {
    if ((subscriptionPlanDetails.max_storage_mb / 1000000 === 6) && product_name === 'Premium') {
      setIsDisabledUpgrade(true);
    }
  }, [size]);
  useEffect(() => {
    setSubscriptionPlanDetails({
      subscriptionPlan: subscriptionDetails?.subscription?.plan,
      plan_price: subscriptionDetails?.plan_price,
      plan_price2: subscriptionDetails?.plan_price2,
      forStandard: price_id,
      myPlanName: subscriptionDetails?.current_plan,
      planaction2: subscriptionDetails?.planaction2,
      planaction: subscriptionDetails?.planaction,
      disk_used_mb: subscriptionDetails?.disk_used_mb,
      total_viewer: subscriptionDetails?.total_viewer,
      max_storage_mb: parseInt(subscriptionDetails?.subscription?.max_storage_mb),
      subscription: (typeof subscriptionDetails?.subscription === 'string'
        || subscriptionDetails?.subscription instanceof String)
        ? subscriptionDetails?.subscription : undefined,
      id: subscriptionDetails?.subscription?.id,
      status: subscriptionDetails?.subscription?.status,
      degrade: subscriptionDetails?.degrade,
      upgrade: subscriptionDetails?.upgrade,
      isNewUser: subscriptionDetails?.is_newUser,
      isFree: subscriptionDetails?.subscription?.is_free,
      hasActivePlan: subscriptionDetails?.has_activePlan,
      paymentMethods: subscriptionDetails?.paymentMethods,
      isAddonAllowed: subscriptionDetails?.is_addon_allowed,
      amount: subscriptionDetails?.subscription?.amount,
      addonRate: subscriptionDetails?.subscription?.addon_rate,
      totalStorageText: subscriptionDetails?.subscription?.total_storage_text,
      totalStorage: subscriptionDetails?.subscription?.total_storage,
      maxAddonAllowedText: subscriptionDetails?.subscription?.max_add_on_allowed_text,
      maxAddonAllowed: subscriptionDetails?.subscription?.max_add_on_allowed,
      isUnlimited: subscriptionDetails?.subscription?.is_unlimited,
      maxViewRequest: subscriptionDetails?.subscription?.max_view_request,
      paymentProcessing: parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 4 && subscriptionDetails?.has_activePlan,
      paymentProcessingText: planText?.paymentProcessing || 'Payment Processing',
      paymentRetry: parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 2 && subscriptionDetails?.has_activePlan,
      paymentRetryText: planText?.paymentRetry || 'Payment Retry',
      purchasePlanId: subscriptionDetails?.subscription?.purchase_plan_id
    });
    if (currentPlanId && subscriptionPlanDetails.hasActivePlan) {
      setMoney(parseInt(subscriptionPlanDetails.amount) / 100);
      setSize(subscriptionPlanDetails.totalStorageText);
      setCurrentPlanBenefit(`Add ${subscriptionPlanDetails.maxAddonAllowedText} of storage for 
      $${(subscriptionPlanDetails?.addonRate / 100).toFixed(2)}/month`);
      setPlanViewer(subscriptionPlanDetails?.isUnlimited === '1' ? (planText?.unlimited || 'unlimited') : subscriptionPlanDetails?.maxViewRequest);
    }
  }, [subscriptionDetails]);

  const handleChange = (event) => {
    const priceValue = parseFloat(subscriptionPlanDetails.amount) / 100;
    const addon = parseFloat(subscriptionPlanDetails?.addonRate) / 100;
    let space = parseFloat(subscriptionPlanDetails.totalStorage);
    if (isAddOn) {
      setMoney(priceValue);
      setSize(subscriptionPlanDetails.totalStorageText);
    } else {
      setMoney(priceValue + addon);
      space += parseFloat(subscriptionPlanDetails.maxAddonAllowed);
      setSize(checkSize(space));
    }
    setIsAddon(!isAddOn);
  };

  let option;
  const DEGRADE_PLAN = 'Chang';
  const UPGRADE_PLAN = 'Upgrad';
  const isNotFree = subscriptionPlanDetails.subscriptionPlan !== 'Free'
    && subscriptionPlanDetails.subscriptionPlan !== undefined;

  if (subscriptionPlanDetails.degrade?.includes(planId)) {
    option = DEGRADE_PLAN;
  } else if (subscriptionPlanDetails.upgrade?.includes(planId)) {
    option = UPGRADE_PLAN;
  }
  const handleCheckout = async (checkoutPlanId) => {
    try {
      setExpressLoading(true);
      const body = new FormData();
      body.append('amount', amount);

      const stripe = await stripePromise;
      // When manager is accessing a user, use manager's token for purchasing
      const tokenForPurchase = userAccessedData && mangerToken ? mangerToken : getToken();

      const response = await fetch(`${baseUrl}/elements/create-payment-intent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: tokenForPurchase,
          userId,
          plan_id: checkoutPlanId,
          url: window.location.origin,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setAppSnackbar({ isVisible: true, type: 'success', message: 'Plan Purchased Successfully' });
      setExpressLoading(false);
      // Return to the billing page so the just-purchased plan is shown refreshed.
      // We intentionally do NOT switch the manager back to their own account here:
      // staying in the accessed user's account lets the manager see the user's new
      // plan on the billing page (which re-fetches subscription/profile on mount).
      setTimeout(() => {
        navigate(Pathname.getSettingsPath(Pathname.settings.billings));
      }, 1200);
    } catch (error) {
      console.error('Checkout failed:', error);
    }
  };

  const openTrailClick = (e, id) => {
    setAffliatePlanId(id);
    setCurrentSelectedPlan(plan);
    localStorage.setItem('trial', e);
    setIsTrail(e);
    setTrial(e);
    localStorage.setItem('planId', planId);
    navigate('/pay-by-manger');
  };
  const handleSwitchToggle = async () => {
    setIsSwitchPlan((prev) => (prev === '0' ? '1' : '0'));
  };

  // ---- Affiliate pricing (from getAllActivePlans for_affiliate) ----
  // Always display the BE-provided effective_amount; never compute discounts here.
  const aff = plan?.affiliate;
  const baseAmt = Number(plan?.amount);
  const affEff = aff ? Number(aff.effective_amount) : null;
  const isFreeNext = aff?.discount?.type === 'percentage' && Number(aff?.discount?.value) === 100;
  const discLabel = (d) => {
    if (!d || !d.value) return '';
    return d.type === 'percentage' ? `${d.value}% off` : `$${(Number(d.value) / 100).toFixed(2)} off`;
  };
  let affNote = '';
  if (aff) {
    if (isFreeNext) {
      const after = discLabel(aff.after_limit_discount);
      affNote = `${aff.free_remaining} of ${aff.free_limit} left${after ? ` · then ${after}` : ''}`;
    } else {
      // limit exceeded, or no free tier, or a plain discount → "{value}% off"
      affNote = discLabel(aff.discount);
    }
  }

  return (
<div>
{/* {totalTrialDays !== '0' && totalTrialDays > 0 && (
  <p className={styles.daysTrails}>
    {totalTrialDays}
    {' '}
    Day Trial
  </p>
)} */}

    <div className={cn({ [styles.col]: true, [styles.plan_blue]: color === 'blue', [styles.eachPlan]: true })}>
      <div>
        <div className={styles.plan_head}>
          <div className={styles.plan_name}>
            <p>{product_name}</p>
            {hasTrial === '1' && (
            <span>
              {totalTrialDays}
              {' '}
              {totalTrialDays === '1' ? 'day ' : 'days '}
              free trial
            </span>
            )}
          </div>

          <div className={styles.plan_price}>
            {aff ? (
              <>
                <p style={{
                  display: 'flex', alignItems: 'baseline', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap',
                }}
                >
                  {isFreeNext ? (
                    <span style={{
                      background: '#1f9d57', color: '#fff', padding: '2px 12px', borderRadius: 999, fontSize: '0.5em', fontWeight: 800, letterSpacing: '0.04em',
                    }}
                    >
                      FREE
                    </span>
                  ) : (
                    <span>
                      $
                      {affEff.toFixed(2)}
                    </span>
                  )}
                  {affEff < baseAmt && (
                    <span style={{
                      textDecoration: 'line-through', opacity: 0.5, fontSize: '0.55em', fontWeight: 600,
                    }}
                    >
                      $
                      {baseAmt.toFixed(2)}
                    </span>
                  )}
                </p>
                {affNote && (
                  <p style={{
                    fontSize: 12, fontWeight: 600, opacity: 0.85, margin: '2px 0 0',
                  }}
                  >
                    {affNote}
                  </p>
                )}
                <p>{price_description}</p>
              </>
            ) : (
              <>
                <p>
                  $
                  {amount}
                </p>
                <p>{price_description}</p>
              </>
            )}
          </div>
        </div>

        {description && (
        <ul className={styles.plan_body}>
          {
            description?.split(',').map((feature, index) => (
              <li key={index}>
                <span className={styles.feat}>{feature}</span>
                <img
                  className={cn(styles.tickster, { [styles.ticksterWhite]: color === 'blue' })}
                  src={TickCircle}
                  alt=""
                />
              </li>
            ))
          }
        </ul>
        )}
      </div>

      <div className={styles.feature}>
        {(subscriptionPlanDetails.isAddonAllowed && subscriptionPlanDetails.hasActivePlan && currentPlanId) && (
          <>
            <div className={styles.featureIcon}>
              <Radio
                checked={isAddOn}
                onClick={handleChange}
                value="a"
                name="radio-button-demo"
                inputProps={{ 'aria-label': 'A' }}
                color="primary"
                style={{ padding: '0' }}
              />
            </div>
            {/* <img alt="viewers" src={viewersIcon} className={styles.featureIcon} /> */}
            <div
              className={cn({ [styles.featureText]: true, [styles.featureTextWhite]: color === 'blue', [styles.featureTextBlue]: color === 'white' })}
            // className={styles.featureText}
            >
              {currentPlanBenefit}
            </div>
          </>
        )}
      </div>
        <>
        {needToggle && (
<div className={styles.toogleAbsolute}>
            {hideToggle !== '3' && (
 <div className={styles.toggleContainer}>
      <div
        className={styles.toggleSwitch}
        onClick={handleSwitchToggle}
      >
              <p className={styles.backText}>Monthly</p>
              <p className={styles.backText}>Annually</p>
        <div
          className={`${styles.toggleButton} ${isSwitchPlan === '1' ? styles.yearly : styles.monthly}`}
        >
          <span className={styles.toggleText}>{isSwitchPlan === '1' ? 'Annually' : 'Monthly' }</span>
        </div>
      </div>
 </div>
          )}
</div>
)}
          <div className={styles.absoluteButton}>
      { hasTrial === '1' && (
        <Button
              onClick={() => openTrailClick('1', planId)}
              text={`Start ${totalTrialDays} day trial`}
              btnClass={color === 'blue' ? 'white' : 'blue'}
            //   isDisabled={(subscribingPlan || (currentPlanId && subscriptionPlanDetails.paymentProcessing) || (!currentPlanId && (subscriptionPlanDetails.paymentProcessing || subscriptionPlanDetails.paymentRetry)) || paymentRetrying || userDetails?.isSubscription) && !subscriptionDetails?.expired}
        />
        )}
            <Button
              onClick={() => { AffliateSpecial ? handleCheckout(planId) : openTrailClick('0', planId); }}
              text="Buy Now"
              isDisabled={expressloading}
              btnClass={color === 'blue' ? styles.buyNow_blue : styles.buyNow}
            />
          </div>
        </>
    </div>
</div>
  );
};
export default AffliatePlan;
